// const serverIP = "http://13.200.67.193:443" // "http://13.200.67.193:80"
// const localIP = "http://172.16.9.48:5003"   //"capd-be.capd.svc.cluster.local:3000"  //"http://192.168.0.15:30337"
// const localIP = "https://capd-be.jssish.com:443"  //"http://127.0.0.1:3000"   //"capd-be.capd.svc.cluster.local:3000"  //"http://192.168.0.15:30337"
// const localIP = "http://127.0.0.2:3001"   //"capd-be.capd.svc.cluster.local:3000"  //"http://192.168.0.15:30337"
 
const localIP = process.env.REACT_APP_API_URL;
console.log(process.env.REACT_APP_API_URL);
const backendIP = localIP;   
export default backendIP;